export default "__VITE_ASSET__CRV6tr$K__"